export default __webpack_public_path__ + "static/media/speakers.40dd9658.svg";